import {Box, useTheme} from "@mui/material";
import {observer} from "mobx-react";
import PageSkeleton from "./PageSkeleton";

function LayoutContentWrapper({renderContent, isLoading, skeleton}) {
    const theme = useTheme();
    const style = styles(theme);

    return (
        <Box sx={style.contentWrapper}>
            {isLoading ? (skeleton || <PageSkeleton/>) : renderContent()}
        </Box>
    )
}

export default observer(LayoutContentWrapper)

const styles = (theme) => ({
    contentWrapper: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        height: '100%',
    },
    spinner: {
        color: theme.palette.primary.main
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        alignItems: 'center'
    }
})